import type { DeviceDistributionWebSourceData } from "../types";

export const calculateShareValues = (data: DeviceDistributionWebSourceData) => {
    const total = data.Desktop + data["Mobile Web"];

    if (total !== 0) {
        const desktopValue = data.Desktop / total;
        const mobileWebValue = data["Mobile Web"] / total;

        return [desktopValue, mobileWebValue];
    }

    return [0, 0];
};
